import { Route, Routes } from "react-router-dom";
import AssessmentFlow from "../flows/AssessmentFlow";
import CohortFlow from "../flows/CohortFlow";
import ResultFlow from "../flows/ResultFlow";

const ShikshakApp = () => {
  return (
    <>
      <Routes>
        <Route path="*" element={<AssessmentFlow />} />
        <Route path="cohort" element={<CohortFlow />} />
        <Route path="result" element={<ResultFlow />} />
      </Routes>
    </>
  );
};

export default ShikshakApp;
